<div class="m-[52px] mt-[87px] pb-[63px]" id="printEoi">
  <div
    class="flex justify-between items-center ml-[40px] mt-[40px] mr-[1.3rem]"
  >
    <div class="flex flex-col items-end">
      <h3 class="title">Expression Of Interest</h3>
    </div>
    <div class="flex items-center gap-[10px]">
      <button (click)="print()" class="print-button">Print</button>
      <img
        src="assets/images/logo.png"
        alt="logo"
        class="h-[78px] w-[78px] rounded-[7px]"
      />
    </div>
  </div>
  <div
    class="header ml-[1.5rem] mr-[1rem] h-[55px] flex justify-start items-center pl-[14px] mt-[30px] bg-[#F1F3F5]"
  >
    <p class="!m-0 pl-[0.3rem]">Project Brief</p>
  </div>
  <div class="px-[1.6875rem] mt-[0.8rem]">
    <app-brief-section></app-brief-section>
  </div>

  <div
    class="header ml-[1.5rem] mr-[1rem] h-[55px] flex justify-start items-center pl-[14px] mt-[1.2rem] mb-[18px] bg-[#F1F3F5]"
  >
    <p class="!m-0 pl-[0.3rem]">Selected Work Packages</p>
  </div>
  <div class="px-[1.6875rem]">
    <div class="w-[50%] mt-[7px] ml-[14px]">
      <div
        *ngFor="
          let orgDetail of eoiSubmittedData?.selected_work_packages;
          let i = index
        "
        class="w-[100%] !h-[49px] flex justify-between items-center"
      >
        <div class="flex justify-start">
          <img
            src="assets/icons/checkbox.png"
            class="h-[20px] w-[20px] mr-[12px]"
            alt="checkbox"
          />
          <p class="packages-name">{{ orgDetail?.name }}</p>
        </div>
      </div>
    </div>
  </div>

  <div
    class="header h-[55px] ml-[1.5rem] mr-[1rem] flex justify-start items-center pl-[14px] mt-[60px] mb-[18px] bg-[#F1F3F5]"
  >
    <p class="!m-0 pl-[0.3rem]">Eligibility Criteria</p>
  </div>
  <div class="px-[1.6875rem]">
    <div class="w-[100%] mt-[7px] ml-[12px]">
      <div class="w-[100%] flex justify-between items-center">
        <div class="flex justify-start">
          <p
            class="breif-value"
            [innerHTML]="
              getSanitizedHtml(eoiSubmittedData?.eligibility_criteria)
            "
          ></p>
        </div>
      </div>
    </div>
  </div>

  <div class="px-[1.6875rem]">
    <div class="w-[100%] mt-[7px] ml-[12px]">
      <div
        class="flex justify-between w-[400px]"
        *ngIf="eoiSubmittedData?.submission_date"
      >
        <p class="eoi-date">EOI Submission Closing</p>
        <p class="eoi-date-value">
          {{ transformDate(eoiSubmittedData?.submission_date) }}
        </p>
      </div>
      <div
        class="flex justify-between w-[400px]"
        *ngIf="eoiSubmittedData?.inquiry_deadline"
      >
        <p class="eoi-date">EOI Inquiry Deadline</p>
        <p class="eoi-date-value">
          {{ transformDate(eoiSubmittedData?.inquiry_deadline) }}
        </p>
      </div>
    </div>

    <div class="container mt-[40px]">
      <div class="ml-[0.8rem] mt-[51px]">
        <!-- applicant detail -->

        <div class="flex justify-start items-center !mt-5">
          <h4 class="applicant-detail">Applicant Details</h4>
        </div>
        <div class="grid grid-cols-3 gap-y-6 gap-x-[25rem] mt-[40px]">
          <div class="flex flex-col">
            <p class="header-attribute">Company Name</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.company_name }}
            </p>
          </div>
          <div class="flex flex-col">
            <p class="header-attribute">Contact Person</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.contact_person }}
            </p>
          </div>
          <div class="flex flex-col">
            <p class="header-attribute">Company Registration Number</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.company_reg_no }}
            </p>
          </div>

          <div class="flex flex-col">
            <p class="header-attribute">Position</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.contact_person_position }}
            </p>
          </div>
          <div class="flex flex-col">
            <p class="header-attribute">VAT Registration Number</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.company_vat_no }}
            </p>
          </div>
          <div class="flex flex-col">
            <p class="header-attribute">Email</p>
            <p class="header-attribute-value">{{ applicantViewData?.email }}</p>
          </div>

          <div class="flex flex-col">
            <p class="header-attribute">Website</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.website }}
            </p>
          </div>
          <div class="flex flex-col">
            <p class="header-attribute">Telephone</p>
            <p class="header-attribute-value">{{ applicantViewData?.phone }}</p>
          </div>
          <div class="flex flex-col">
            <p class="header-attribute">Address</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.address }}
            </p>
          </div>

          <div class="flex flex-col">
            <p class="header-attribute">City</p>
            <p class="header-attribute-value">{{ applicantViewData?.city }}</p>
          </div>
          <div class="flex flex-col">
            <p class="header-attribute">Country</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.country_id }}
            </p>
          </div>
          <div class="flex flex-col">
            <p class="header-attribute">State/Province</p>
            <p class="header-attribute-value">{{ applicantViewData?.state }}</p>
          </div>

          <div class="flex flex-col">
            <p class="header-attribute">Zip Code</p>
            <p class="header-attribute-value">{{ applicantViewData?.zip }}</p>
          </div>
          <!-- Empty cells -->
          <div></div>
          <div></div>
        </div>

        <!-- scope of interest -->

        <div class="flex justify-start items-center mt-[36px]">
          <h4 class="applicant-detail">Scope of Interest</h4>
        </div>
        <div class="grid grid-cols-3 gap-y-6 gap-x-[25rem] mt-[40px]">
          <div class="flex flex-col">
            <p class="header-attribute">Nature of service Required</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.nature_of_service }}
            </p>
          </div>
          <div class="flex flex-col">
            <p class="header-attribute">Type of Project</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.type_of_project }}
            </p>
          </div>
          <div class="flex flex-col">
            <p class="header-attribute">Project location</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.project_location }}
            </p>
          </div>

          <div class="flex flex-col">
            <p class="header-attribute">Estimation Project value</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.estimation_price }}
            </p>
          </div>
          <div class="flex flex-col">
            <p class="header-attribute">Expected Start Date</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.expected_start_date | date : "yyyy-MM-dd" }}
            </p>
          </div>
          <div class="flex flex-col">
            <p class="header-attribute">Expected End Date</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.expected_end_date | date : "yyyy-MM-dd" }}
            </p>
          </div>

          <!-- Empty cells -->
          <div></div>
          <div></div>
        </div>

        <!-- Experience & Capability (If Applicable) -->

        <div class="flex justify-start items-center mt-[36px]">
          <h4 class="applicant-detail">
            Experience & Capability(If Applicable) 
          </h4>
        </div>
        <div class="grid grid-cols-3 gap-y-6 gap-x-[25rem] mt-[40px]">
          <div class="flex flex-col">
            <p class="header-attribute">Relevant Experience</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.experience }}
            </p>
          </div>
          <div class="flex flex-col">
            <p class="header-attribute">Key Qualifications</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.qualifications }}
            </p>
          </div>
          <div class="flex flex-col">
            <p class="header-attribute">Team Composition</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.team_composition }}
            </p>
          </div>

          <!-- Empty cells -->
          <div></div>
          <div></div>
        </div>

        <!--  Compliance & Policies -->

        <div class="flex justify-start items-center mt-[36px]">
          <h4 class="applicant-detail">Compliance & Policies</h4>
        </div>
        <div class="grid grid-cols-3 gap-y-6 gap-x-[25rem] mt-[40px]">
          <div class="flex flex-col">
            <p class="header-attribute">
              Health, Safety & Environmental Policy
            </p>
            <p class="header-attribute-value">
              {{ applicantViewData?.health_safety_environmental_policy }}
            </p>
          </div>
          <div class="flex flex-col">
            <p class="header-attribute">Quality Assurance Certification</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.quality_assurance_cert_attach }}
            </p>
          </div>
          <div class="flex flex-col">
            <p class="header-attribute">Conflict of Interest Disclosure</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.conflict_of_interest }}
            </p>
          </div>

          <!-- Empty cells -->
          <div></div>
          <div></div>
        </div>

        <!--  Additional Information -->

        <div
          *ngIf="applicantViewData?.additional_information"
          class="flex justify-start items-center mt-[36px]"
        >
          <h4 class="applicant-detail">Additional Information</h4>
        </div>
        <p class="header-attribute-value" style="margin-top: 20px !important">
          {{ applicantViewData?.additional_information }}
        </p>

        <!--   Declaration -->

        <div class="flex justify-start items-center mt-[36px]">
          <h4 class="applicant-detail">Declaration</h4>
        </div>
        <div class="grid grid-cols-3 gap-y-6 gap-x-[25rem] mt-[40px] mb-[40px]">
          <div class="flex flex-col">
            <p class="header-attribute">Name of Authorized Representative</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.authorized_representative }}
            </p>
          </div>
          <div class="flex flex-col">
            <p class="header-attribute">Position</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.authorized_representative_position }}
            </p>
          </div>
          <div class="flex flex-col">
            <p class="header-attribute">Signature</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.signature }}
            </p>
          </div>
          <div class="flex flex-col">
            <p class="header-attribute">Date</p>
            <p class="header-attribute-value">
              {{ applicantViewData?.date | date : "yyyy-MM-dd" }}
            </p>
          </div>

          <!-- Empty cells -->
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Dialog content -->
  <ng-template #dialogTemplate class="w-[100%]">
    <h2 mat-dialog-title>Print Preview</h2>
    <mat-dialog-content>
      <div>eofjseofielfin</div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button (click)="closeDialog()" class="mr-[30px]">
        Close
      </button>
      <button (click)="print()" class="print-button">Print</button>
    </mat-dialog-actions>
  </ng-template>
</div>
